import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DiscrepanciesData } from '../../kitchen/shared/domain/discrepancies-data.model';
import { Observable } from 'rxjs';
import { DiscrepanciesRequest } from '../../kitchen/shared/domain/discrepancies-request.model';

@Injectable()
export class AdStatsDiscrepanciesService {

  constructor(private httpClient: HttpClient) {
  }

  discrepancies(request: DiscrepanciesRequest): Observable<DiscrepanciesData[]> {
    return this.httpClient.post<DiscrepanciesData[]>(`${environment.serviceUrl}/ad-stats/ad-stats/ad-reports/discrepancies`, request);
  }
}
